function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint react/no-did-update-set-state: "off" */
import React, { PureComponent } from 'react';
import { LoadingSpinner, SelectValueList, FadeTransition } from '@deephaven/components';
import Log from '@deephaven/log';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('AdvancedFilterCreatorSelectValueList');
/**
 * Select values from a long scrollable list.
 * Swaps items in and out for infinite scrolling
 */
class AdvancedFilterCreatorSelectValueList extends PureComponent {
  /**
   * Get the index of a value in an array. Has some special handling for some types, like DateTimes and Longs.
   * @param value The value to search for
   * @param values The array of values to search within
   */
  static indexOf(value, values) {
    for (var i = 0; i < values.length; i += 1) {
      var v = values[i];
      if (v === value || v != null && v.valueOf != null && value != null && value.valueOf != null && v.valueOf() === value.valueOf()) {
        return i;
      }
    }
    return -1;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "dh", void 0);
    _defineProperty(this, "list", void 0);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
    this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this);
    this.handleTableUpdate = this.handleTableUpdate.bind(this);
    var _this$props = this.props,
      selectedValues = _this$props.selectedValues,
      dh = _this$props.dh;
    this.dh = dh;
    this.list = null;
    this.state = {
      itemCount: 0,
      items: [],
      offset: 0,
      selectedValues,
      isLoading: true
    };
  }
  componentDidMount() {
    var table = this.props.table;
    if (table) this.startListening(table);
  }
  componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
      filters = _this$props2.filters,
      invertSelection = _this$props2.invertSelection,
      selectedValues = _this$props2.selectedValues,
      table = _this$props2.table;
    if (prevProps.table !== table) {
      if (prevProps.table) this.stopListening(prevProps.table);
      if (table) this.startListening(table);
      this.resetViewport();
    }
    if (prevProps.invertSelection !== invertSelection) {
      this.setState({
        selectedValues: []
      }, this.handleSelectionUpdate);
    }
    if (prevProps.selectedValues !== selectedValues) {
      this.setState({
        selectedValues
      }, this.handleSelectionUpdate);
    }
    if (prevProps.filters !== filters) {
      table === null || table === void 0 || table.applyFilter(filters);
      this.resetViewport();
    }
  }
  componentWillUnmount() {
    var table = this.props.table;
    if (table) this.stopListening(table);
  }
  handleSelect(itemIndex, value) {
    var invertSelection = this.props.invertSelection;
    var selectedValues = this.state.selectedValues;
    selectedValues = [...selectedValues];
    var selectedIndex = AdvancedFilterCreatorSelectValueList.indexOf(value, selectedValues);
    if (selectedIndex >= 0) {
      selectedValues.splice(selectedIndex, 1);
    } else {
      selectedValues.push(value);
    }
    var isSelected = selectedIndex < 0;
    if (invertSelection) {
      isSelected = !isSelected;
    }
    var offset = this.state.offset;
    var items = this.state.items;
    items = [...items];
    var visibleItemIndex = itemIndex - offset;
    if (visibleItemIndex >= 0 && visibleItemIndex < items.length) {
      items[visibleItemIndex].isSelected = isSelected;
    }
    this.setState({
      items,
      selectedValues
    });
    var onChange = this.props.onChange;
    onChange(selectedValues, invertSelection);
  }
  handleViewportChange(top, bottom) {
    this.updateViewport(top, bottom);
  }
  handleSelectionUpdate() {
    this.updateItemSelection();
  }
  handleTableUpdate(event) {
    var _this$props3 = this.props,
      table = _this$props3.table,
      formatter = _this$props3.formatter;
    if (!table) return;
    var data = event.detail;
    var offset = data.offset;
    var items = [];
    var column = table.columns[0];
    for (var r = 0; r < data.rows.length; r += 1) {
      var row = data.rows[r];
      var value = row.get(column);
      var displayValue = void 0;
      if (value == null) {
        displayValue = /*#__PURE__*/_jsx("i", {
          className: "text-muted",
          children: "null"
        });
      } else if (value === '') {
        displayValue = /*#__PURE__*/_jsx("i", {
          className: "text-muted",
          children: "empty"
        });
      } else {
        displayValue = formatter.getFormattedString(value, column.type, column.name);
      }
      var isSelected = this.isValueSelected(value);
      items.push({
        displayValue,
        value,
        isSelected
      });
    }
    log.debug2('Received table update:', offset, items.length);
    var itemCount = table.size;
    this.setState({
      itemCount,
      items,
      offset,
      isLoading: false
    });
  }
  isValueSelected(value) {
    var invertSelection = this.props.invertSelection;
    var selectedValues = this.state.selectedValues;

    // Need to check if any of the valueOf matches, timestamp value that is equal
    var selectedIndex = AdvancedFilterCreatorSelectValueList.indexOf(value, selectedValues);
    return invertSelection ? selectedIndex < 0 : selectedIndex >= 0;
  }
  startListening(table) {
    table.addEventListener(this.dh.Table.EVENT_UPDATED, this.handleTableUpdate);
  }
  stopListening(table) {
    table.removeEventListener(this.dh.Table.EVENT_UPDATED, this.handleTableUpdate);
  }
  resetViewport() {
    if (this.list && this.list.topRow != null && this.list.bottomRow != null) {
      this.updateViewport(this.list.topRow, this.list.bottomRow, true);
    }
  }
  updateItemSelection() {
    var items = this.state.items;
    items = [...items];
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var value = item.value;
      item.isSelected = this.isValueSelected(value);
    }
    this.setState({
      items
    });
  }
  updateViewport(top, bottom) {
    var isLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var table = this.props.table;
    if (table == null) {
      return;
    }
    if (isLoading) {
      this.setState({
        isLoading: true
      });
    }
    var viewportSize = bottom - top + 1;
    var topRow = Math.max(0, top - viewportSize * 3);
    var bottomRow = Math.max(topRow, bottom + viewportSize * 3);
    log.debug2('Setting viewport', topRow, ',', bottomRow);
    table.setViewport(topRow, bottomRow);
  }
  render() {
    var _this$state = this.state,
      offset = _this$state.offset,
      isLoading = _this$state.isLoading,
      items = _this$state.items,
      itemCount = _this$state.itemCount;
    return /*#__PURE__*/_jsxs("div", {
      className: "select-value-list-wrapper",
      children: [/*#__PURE__*/_jsx(SelectValueList, {
        itemCount: itemCount,
        items: items,
        offset: offset,
        onSelect: this.handleSelect,
        onViewportChange: this.handleViewportChange,
        ref: list => {
          this.list = list;
        }
      }), /*#__PURE__*/_jsx(FadeTransition, {
        in: isLoading,
        mountOnEnter: true,
        unmountOnExit: true,
        children: /*#__PURE__*/_jsx("div", {
          className: "loading-list",
          children: /*#__PURE__*/_jsx(LoadingSpinner, {
            className: "loading-spinner-large"
          })
        })
      })]
    });
  }
}
_defineProperty(AdvancedFilterCreatorSelectValueList, "defaultProps", {
  invertSelection: true,
  selectedValues: [],
  onChange: () => undefined
});
export default AdvancedFilterCreatorSelectValueList;
//# sourceMappingURL=AdvancedFilterCreatorSelectValueList.js.map